import { type ReactNode } from 'react';

import { css } from '@sorare/css';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';

const root = css`
  position: relative;
  z-index: 1;
  padding: 0 var(--double-unit) var(--quadruple-unit);
  gap: var(--double-unit);
  width: 100%;
`;

const placeholder = css`
  height: 40px;
`;

type Props = {
  primaryAction: ReactNode;
  secondaryAction?: ReactNode;
};

export const BottomActions = ({ primaryAction, secondaryAction }: Props) => (
  <Vertical className={root}>
    {primaryAction}
    {secondaryAction ?? <div className={placeholder} />}
  </Vertical>
);
